import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Assessor List")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Phase", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Institute", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Status", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "col-md-1 mt-2 p-0" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "d-flex pt-4 pb-2"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-4 text-gray-600" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "mt-2" })
    ])
  ])
], -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" })
], -1)
const _hoisted_25 = { class: "card mb-5 mb-xl-10" }
const _hoisted_26 = {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#assessor_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_27 = { class: "row mt-1 w-100 m-0" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_29 = { class: "row w-100 mb-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_31 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  id: "assessor_data",
  class: "collapse show"
}
const _hoisted_39 = { class: "collapse show" }
const _hoisted_40 = { class: "card-body border-top p-6" }
const _hoisted_41 = {
  class: "current",
  "data-kt-stepper-element": "content",
  id: "datatableId"
}
const _hoisted_42 = ["src"]
const _hoisted_43 = ["src"]
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { key: 2 }
const _hoisted_47 = { key: 3 }
const _hoisted_48 = { key: 4 }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_50 = ["onClick"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-pencil-alt" }, null, -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check text-light" }, null, -1)
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ban text-light" }, null, -1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-slash text-light" }, null, -1)
const _hoisted_61 = [
  _hoisted_60
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_Form = _resolveComponent("Form")!
  const _component_OrganizationModal = _resolveComponent("OrganizationModal")!
  const _component_AssessorEditDrawer = _resolveComponent("AssessorEditDrawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Form, {
      onSubmit: _cache[9] || (_cache[9] = ($event: any) => (_ctx.formSubmit())),
      class: "form",
      "validation-schema": _ctx.AssociationSchema
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _hoisted_10,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        "collapse-tags": "",
                        "collapse-tags-tooltip": "",
                        placeholder: "Select Phase",
                        modelValue: _ctx.batch.tranche,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche) = $event)),
                        multiple: "",
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranche, (trans) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: trans.id,
                              label: trans.label,
                              value: trans.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(trans.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_component_el_select, {
                        "collapse-tags": "",
                        "collapse-tags-tooltip": "",
                        class: "form-select-solid",
                        placeholder: "Select Training Partner",
                        modelValue: _ctx.batch.entity_id,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                        style: {"width":"100%"},
                        multiple: "",
                        filterable: "",
                        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterEntity(_ctx.batch.entity_id)))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.association, (data) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: data.id,
                              label: 
                        '[' + data.entity_short_name + '] - ' + data.entity_name
                      ,
                              value: data.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString('[' + data.entity_short_name + '] - ' + data.entity_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "entity_id",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _hoisted_15,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Training Institute",
                        modelValue: _ctx.batch.institute_info_id,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.institute_info_id) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.institutes, (inst) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: inst.id,
                              label: inst.institute_name,
                              value: inst.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(inst.institute_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "institute_info_id",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _hoisted_18,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select status",
                        modelValue: _ctx.batch.active_status,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.batch.active_status) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Active",
                            value: "1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Active")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inactive",
                            value: "3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Inactive")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Pending",
                            value: "0"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Pending")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Suspend",
                            value: "4"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Suspend")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Reject",
                            value: "2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Reject")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "institute_info_id",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.assessorInfo())),
                        type: "button",
                        class: "btn btn-success mt-6 p-3",
                        style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                      }, [
                        _createTextVNode(" Search "),
                        _hoisted_20
                      ])
                    ])
                  ]),
                  (_ctx.showCourseNotice == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                    : _createCommentVNode("", true),
                  (_ctx.showCourseNotice == true)
                    ? (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                        _hoisted_24,
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _hoisted_28,
                              _createElementVNode("div", _hoisted_29, [
                                _hoisted_30,
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                    title: "Download Xlse",
                                    "data-v-54b12dc8": "",
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.exportTrainee()))
                                  }, _hoisted_33),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                    title: "Download PDF",
                                    "data-v-54b12dc8": "",
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.downloadPdf()))
                                  }, _hoisted_35),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                    title: "Print",
                                    "data-v-54b12dc8": "",
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.printPdf()))
                                  }, _hoisted_37)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("div", _hoisted_41, [
                                  _createVNode(_component_Datatable, {
                                    "table-data": _ctx.assessorList,
                                    "table-header": _ctx.tableHeader,
                                    "enable-items-per-page-dropdown": true
                                  }, {
                                    "cell-sl": _withCtx(({ row }) => [
                                      _createTextVNode(_toDisplayString(row.id), 1)
                                    ]),
                                    "cell-photo": _withCtx(({ row: assessorList }) => [
                                      (assessorList?.attach_file_info?.file_path)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            style: {"width":"50px","height":"50px"},
                                            src: 
                                  _ctx.api_url +
                                  assessorList?.attach_file_info?.file_path
                                ,
                                            alt: ""
                                          }, null, 8, _hoisted_42))
                                        : (_openBlock(), _createElementBlock("img", {
                                            key: 1,
                                            style: {"width":"50px","height":"50px"},
                                            src: 
                                  _ctx.api_url +
                                  '/storage/images/EntityAssessor/' +
                                  assessorList?.attach_file_info
                                    ?.file_name_uploaded
                                ,
                                            alt: ""
                                          }, null, 8, _hoisted_43))
                                    ]),
                                    "cell-uniqueId": _withCtx(({ row: assessorList }) => [
                                      _createTextVNode(_toDisplayString(assessorList?.assessor_number), 1)
                                    ]),
                                    "cell-assessor_name": _withCtx(({ row: assessorList }) => [
                                      _createTextVNode(_toDisplayString(assessorList?.employee_info?.name), 1)
                                    ]),
                                    "cell-gender": _withCtx(({ row: assessorList }) => [
                                      _createTextVNode(_toDisplayString(assessorList?.employee_info?.gender), 1)
                                    ]),
                                    "cell-phone": _withCtx(({ row: assessorList }) => [
                                      _createTextVNode(_toDisplayString(assessorList?.employee_info?.mobile), 1)
                                    ]),
                                    "cell-email": _withCtx(({ row: assessorList }) => [
                                      _createTextVNode(_toDisplayString(assessorList?.employee_info?.email), 1)
                                    ]),
                                    "cell-unique_number": _withCtx(({ row: assessorList }) => [
                                      _createTextVNode(_toDisplayString(assessorList?.assessor_number), 1)
                                    ]),
                                    "cell-area_of_exp": _withCtx(({ row: assessorList }) => [
                                      _createTextVNode(_toDisplayString(assessorList?.area_of_expertise), 1)
                                    ]),
                                    "cell-years_of_exp": _withCtx(({ row: assessorList }) => [
                                      _createTextVNode(_toDisplayString(assessorList?.years_of_exp), 1)
                                    ]),
                                    "cell-status": _withCtx(({ row: assessorList }) => [
                                      (assessorList?.active_status == 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString('Pending')))
                                        : _createCommentVNode("", true),
                                      (assessorList?.active_status == 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString('Active')))
                                        : _createCommentVNode("", true),
                                      (assessorList?.active_status == 3)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString('Inactive')))
                                        : _createCommentVNode("", true),
                                      (assessorList?.active_status == 2)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString('Reject')))
                                        : _createCommentVNode("", true),
                                      (assessorList?.active_status == 4)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString('Suspend')))
                                        : _createCommentVNode("", true)
                                    ]),
                                    "cell-actions": _withCtx(({ row: assessorList }) => [
                                      _createVNode(_component_router_link, {
                                        class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
                                        title: "View",
                                        to: {
                                  name: 'assessor view',
                                  params: { id: assessorList?.id },
                                }
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_49
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]),
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (_ctx.edit(assessorList)),
                                        "data-kt-drawer-toggle": "true",
                                        "data-kt-drawer-target": "#kt_drawer_assessor_list",
                                        title: "Edit",
                                        id: "kt_drawer_assessor_list_button",
                                        class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                      }, _hoisted_52, 8, _hoisted_50),
                                      (
                                  _ctx.actionActive &&
                                  assessorList?.active_status !== 1
                                )
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            onClick: ($event: any) => (_ctx.Active(assessorList?.id)),
                                            title: "Active",
                                            class: "btn btn-icon btn-bg-success btn-active-color-success btn-sm me-1"
                                          }, _hoisted_55, 8, _hoisted_53))
                                        : _createCommentVNode("", true),
                                      (
                                  _ctx.actionActive &&
                                  assessorList?.active_status !== 3
                                )
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            onClick: ($event: any) => (_ctx.Inactive(assessorList?.id)),
                                            title: "Inactive",
                                            class: "btn btn-icon btn-bg-warning btn-active-color-warning btn-sm me-1"
                                          }, _hoisted_58, 8, _hoisted_56))
                                        : _createCommentVNode("", true),
                                      (
                                  _ctx.adminCheck &&
                                  assessorList?.active_status !== 4
                                )
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 2,
                                            onClick: ($event: any) => (_ctx.Suspend(assessorList?.id)),
                                            class: "btn btn-icon btn-bg-danger btn-active-color-primary btn-sm",
                                            title: "Suspend"
                                          }, _hoisted_61, 8, _hoisted_59))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["table-data", "table-header"])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.load]
          ])
        ])), [
          [_directive_loading, _ctx.load]
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"]),
    _createVNode(_component_OrganizationModal),
    _createVNode(_component_AssessorEditDrawer)
  ], 64))
}